var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44922 21L11.8349 2L22.2205 21H1.44922ZM4.70653 19H18.9632L11.8349 6L4.70653 19ZM11.8349 18C12.1024 18 12.3266 17.9042 12.5076 17.7125C12.6885 17.5208 12.779 17.2833 12.779 17C12.779 16.7167 12.6885 16.4792 12.5076 16.2875C12.3266 16.0958 12.1024 16 11.8349 16C11.5673 16 11.3431 16.0958 11.1621 16.2875C10.9812 16.4792 10.8907 16.7167 10.8907 17C10.8907 17.2833 10.9812 17.5208 11.1621 17.7125C11.3431 17.9042 11.5673 18 11.8349 18ZM10.8907 15H12.779V10H10.8907V15Z",
    fill: "#AA013F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.e85b9511060d319656b86aa9d3d5dd61.svg";
export { ForwardRef as ReactComponent };